// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"19d589ab","167":"300ec2e1","518":"f12eb242"}[chunkId] + ".chunk.js";
};